export const stepOneData = [
  {
    heading: "Understanding EMI and Its Importance",
    // paras before heading
    paraOne:
      "An <strong>Equated Monthly Installment (EMI)</strong> is the fixed amount you pay monthly towards repaying your loan. It comprises both the <strong>principal</strong> and <strong>interest</strong> components. Estimating your EMI in advance helps in budgeting and ensures that the loan remains affordable throughout its tenure.",

    subHeadOne: "Impact of Loan Tenure on EMI and Total Repayment",
    subOneList: [
      {
        head: "Shorter Tenure: ",
        text: "Leads to higher EMIs but reduces the total interest payable.",
      },
      {
        head: "Longer Tenure: ",
        text: "Results in lower EMIs but increases the total interest paid over time.",
      },
    ],
    subHeadTwo: "Example: Indian Overseas Bank Personal Loan",
    subTwoList: [
      {
        head: "Loan Amount: ",
        text: "₹5,00,000",
      },
      {
        head: "Interest Rate: ",
        text: "9.85% per annum (as per IOB’s latest rates)",
      },
    ],

    tableContent: {
      heading: [
        {
          head: "Tenure",
        },
        {
          head: "EMI (₹)",
        },
        {
          head: "Total Interest (₹)",
        },
        {
          head: "Total Repayment (₹)",
        },
      ],
      row: [
        {
          tenure: "3 years",
          emi: "16,112",
          interest: "80,032",
          repayment: "5,80,032",
        },
        {
          tenure: "5 years",
          emi: "10,604",
          interest: "1,36,240",
          repayment: "6,36,240",
        },
      ],
    },

    tip: '"Indian Overseas Bank offers flexible repayment tenures ranging from 12 to 60 months. Choose a tenure that balances your EMI affordability and total interest cost."',
  },
];

export const stepTwoData = [
  {
    heading: "Why Consider APR Over Just Interest Rates?",

    paraOne:
      "The <strong>Annual Percentage Rate (APR)</strong> provides a comprehensive view of the loan’s cost by including both the <strong>interest rate</strong> and additional fees like <strong>processing charges</strong>. This helps in comparing different loan offers more effectively.",

    subHeadOne: "Indian Overseas Bank’s APR Details",
    subOneList: [
      {
        head: "Interest Rate: ",
        text: "9.85% per annum",
      },
      {
        head: "Processing Fee: ",
        text: "Up to 1% of the loan amount (subject to change)",
      },
      {
        head: "Other Charges: ",
        text: "GST on processing fees, prepayment charges (if applicable), and late payment fees.",
      },
    ],
    tip: '"Indian Overseas Bank’s processing fee is one of the lowest in the market, but always check for additional charges like GST and prepayment penalties to calculate the true cost of your loan."',
  },
];

export const stepThreeData = [
  {
    heading: "Factors Influencing Your EMI and Total Repayment",

    subOneList: [
      {
        head: "Processing Fees: ",
        text: "Indian Overseas Bank charges a processing fee of up to 1% of the loan amount. This fee is deducted upfront and impacts the total loan cost.",
      },
      {
        head: "Prepayment Charges: ",
        text: "Indian Overseas Bank allows prepayment after 12 EMIs with a nominal charge of 2-3% on the outstanding principal. Confirm the exact charges before opting for prepayment.",
      },
      {
        head: "Late Payment Penalties: ",
        text: "Missing EMI payments can attract a penalty of 2% per month on the overdue amount. Ensure timely payments to avoid additional costs and maintain a good credit score.",
      },
    ],
    tip: '"Indian Overseas Bank offers a grace period for EMI payments. However, late payments beyond the grace period can attract penalties. Set up auto-debit to avoid missing EMIs."',
  },
];

export const stepFourData = [
  {
    heading: "The Importance of Interest Rates in Personal Loans",
    paraOne:
      "The <strong>interest rate</strong> directly impacts your EMI and the total cost of the loan. A lower interest rate reduces both your monthly payments and the overall amount payable.",

    subHeadOne: "Negotiating Interest Rates with Indian Overseas Bank",
    subOneList: [
      {
        head: "Credit Score: ",
        text: "A higher credit score (750 and above) indicates good creditworthiness, which can help you negotiate lower interest rates.",
      },
      {
        head: "Existing Relationship with the Bank: ",
        text: "Indian Overseas Bank offers preferential rates to existing customers. If you have a savings account, credit card, or other products with the bank, use this relationship to negotiate better terms.",
      },
      {
        head: "Market Research: ",
        text: "Compare offers from multiple lenders. Use these comparisons as a basis for negotiation.",
      },
    ],

    tip: '"Indian Overseas Bank provides pre-approved personal loans to existing customers with competitive interest rates. Check your pre-approved offer on the IOB Mobile App or NetBanking portal."',
  },
];

export const stepFiveData = [
  {
    heading: "How Credit Score Affects Interest Rates and EMI",
    paraOne:
      "Your <strong>credit score</strong> is a numerical representation of your creditworthiness. Lenders use it to assess the risk of lending to you.",

    subHeadOne: "Indian Overseas Bank’s Credit Score Criteria",
    subOneList: [
      {
        head: "High Credit Score (750 and above): ",
        text: "Indicates low risk, leading to lower interest rates and EMIs.",
      },
      {
        head: "Moderate Credit Score (650-749): ",
        text: "May result in standard interest rates.",
      },
      {
        head: "Low Credit Score (below 650): ",
        text: "Considered high risk, leading to higher interest rates and EMIs. Difficult to obtain Loan",
      },
    ],
    subHeadTwo: "Improving Your Credit Score",
    subTwoList: [
      {
        head: "Timely Payments: ",
        text: "Always pay your EMIs and credit card bills on time.",
      },
      {
        head: "Credit Utilization Ratio: ",
        text: "Keep your credit card usage below 30% of the limit.",
      },
      {
        head: "Avoid Multiple Loan Applications: ",
        text: "Too many loan inquiries can negatively impact your score.",
      },
    ],

    tip: '"Indian Overseas Bank offers credit score checks through its mobile app. Regularly monitor your credit score and take steps to improve it for better loan terms."',
  },
];
